import {
  params,
  string,
  shape,
  extend,
} from '@thd-nucleus/data-sources';
import {
  universalLayoutFragment
} from '../templates/dataModelTemplate';

export const dataModel = extend(
  {
    layouts: params({
      slug: string().isRequired(),
      customerType: string()
    }).shape({
      content: shape({
        __typename: string(),
        UniversalLayout: universalLayoutFragment
      }),
    }),
  },
  // The below components are supported by dynamic-content but not in use by our project currently.
  // They can be uncommented as needed.
  //
  // Breadcrumbs,
  // BrowseSearchMetadata,
  // CalloutCard,
  // CapabilityCard,
  // CategoryMetadata,
  // ContentAccordion,
  // ContentGalleryCard,
  // DynamicComponentSelector,
  // DynamicSlot,
  // EmtLinks,
  // Endcap,
  // Hero,
  // HeroComponentSelector,
  // HeroPersonalized,
  // HeroSlot,
  // LandingPageRedirector,
  // LandingPageSearchRedirector,
  // MedioInline,
  // MedioComposableBanner,
  // NewspaperModule,
  // PiccolaPencil,
  // PiccolaComposableBanner,
  // ProductShelf,
  // PromoVisualNavigation,
  // RelatedSearch,
  // Resource,
  // ResourceComponentSelector,
  // ResourceSlot,
  // SideNavigation,
  // SpecialBuyBanner,
  // SponsoredBanner,
  // Spotlight,
  // SpotlightContainer,
  // SpotlightComponentSelector,
  // SpotlightSlot,
  // VisualNavigation,
);
